import ResponseEntity from "..";
import {
  IsString,
  IsInt,
  IsBoolean,
  ValidateNested,
  ValidateIf,
} from "class-validator";
import OutputLc from "../lc";
import { Type } from "class-transformer";
import CryptoJS from "crypto-js";

export default class PrivateUser extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsString() public readonly email!: string;
  @IsString() public readonly public_id!: string;
  @IsString() public readonly first_name!: string;
  @IsString() public readonly last_name!: string;
  @IsBoolean() public readonly administrator!: boolean;
  @IsBoolean() public readonly blogger!: boolean;

  @Type(() => OutputLc)
  @ValidateNested()
  public readonly lc!: OutputLc;

  @IsInt() public readonly year!: number;
  @IsBoolean() public readonly is_medicine!: boolean;
  @IsString() public readonly programme_title!: string;
  @IsInt() public readonly series!: number;
  @IsInt() public readonly group!: number;
  @IsString() public readonly registration_number!: string;
  @IsString() public readonly id_image!: string;
  @IsBoolean() public readonly transmed_subscriber!: boolean;
  @IsBoolean() public readonly valid!: boolean;

  @ValidateIf((obj) => obj.validation_message !== null)
  @IsString()
  public readonly validation_message!: string | null;
}

export function getUserPrivateId(user: PrivateUser): string {
  return CryptoJS.SHA256(user.id.toString() + user.public_id).toString(
    CryptoJS.enc.Hex
  );
}
